<div class="preview-container">
  <label class="preview-label">
    <span class="preview-arrow">▶</span>
    {{ labelText }}
  </label>
  <div class="preview-content">
    <span [innerHTML]="formattedText"></span>
  </div>
</div>
